import React from 'react';

const NebulaPerformanceFeeFormModal = React.lazy(() => import('../components/FormModal'));
const nebulaPerformanceFeeModalRegistry = {
    personalize_nebulaPerformanceFeeId: NebulaPerformanceFeeFormModal
};
export default nebulaPerformanceFeeModalRegistry;
